import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';
import { IInventoryRepository } from '@/coreInfrastructureModule/interfaces/IInventoryRepository';
import { OverviewData } from '../pages/useInventoryDashboardStore/types';

/**
 * 在庫削減ダッシュボードの概要情報を取得する
 */
export class GetInventoryDashboardOverviewUseCase {
  private repository: IInventoryRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IInventoryRepository) {
    this.repository = repository;
  }

  /**
   * 在庫削減ダッシュボードの概要取得
   * @returns - 在庫削減ダッシュボードの概要情報
   */
  public async execute(): Promise<INetworkResult<OverviewData, IError>> {
    const networkResult = await this.repository.getInventoryAnalyticsOverview();
    switch (networkResult.status.type) {
      case 'success': {
        const result = networkResult.status.data;
        return {
          status: {
            type: 'success',
            data: {
              totalCurrentInventoryAmount: result.totalCurrentInventoryAmount ? Number(result.totalCurrentInventoryAmount) : undefined,
              averageTurnover: result.averageTurnover ? Number(result.averageTurnover) : undefined,
              averageForecastAccuracy: result.averageForecastAccuracy ? Number(result.averageForecastAccuracy) : undefined,
              averageKpiArchievementRate: undefined, // result.averageKpiArchievementRate ? Number(result.averageKpiArchievementRate) : undefined,
              warningItemsCount: result.warningBusinessCount,
              criticalItemsCount: result.criticalBusinessCount,
            },
          },
        };
      }
      case 'error':
        return { status: { type: 'error', error: networkResult.status.error } };
    }
  }
}
